/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * This directive closes the modal to whose root element it is attached upon clicking outside it.
 *
 * Usage example:
 * <modal-directive-root-element
 *   data-is-modal-open-callback="isModalOpen()"
 *   data-modal-close-callback="closeModal()"
 *   data-modal-identifier-attr="modal-tag">
 * </modal-directive-root-element>
 *
 * Add the modal-tag attribute, which is a unique attribute per modal, to each element which belongs to the modal and needs to be
 * included in the list of elements upon clicking on which the modal will not be closed.
 *
 * isModalOpen() is the function which determines whether or not the modal is open
 * closeModal() is the function which closes the modal
 *
 * @module enervee_utils.common
 */

function closeOnClickOutsideConfig() {
    return {
        restrict: 'A',
        scope: {
            isModalOpenCallback: '&',
            modalIdentifierAttr: '@',
            modalCloseCallback: '&'
        },
        link: closeOnClickOutsideLink
    };
}

function closeOnClickOutsideLink(scope, element, attrs) {
    var $injector = angular.injector(['ng']);
    var $document = $injector.get('$document');
    var KEYCODE_ESC = 27;

    scope.$on('$destroy', function () {
        element.off('keyup', onDocumentKeyup);
        element.off('click', onDocumentClick);
    });

    function onDocumentKeyup(event) {
        if (event.keyCode === KEYCODE_ESC && scope.isModalOpenCallback()) {
            scope.$applyAsync(scope.modalCloseCallback);
        }
    }

    function onDocumentClick(event) {
        if (!scope.isModalOpenCallback()) {
            return;
        }

        var taggedElements = angular.element("[" + scope.modalIdentifierAttr + "]");

        var isClickedElementChild = false;
        for (var i = 0; i <= taggedElements.length; i++) {
            var buttonOrBodyElement = taggedElements[i];
            if (buttonOrBodyElement) {
                isClickedElementChild = buttonOrBodyElement.contains(event.target);
                if (isClickedElementChild) {
                    break;
                }
            }
        }

        var isClickedElementChildOfPopup = element.find(event.target).length > 0;
        if (!isClickedElementChildOfPopup && element[0] !== event.target && !isClickedElementChild) {
            scope.$applyAsync(scope.modalCloseCallback);
        }
    }

    $document.keyup(onDocumentKeyup);
    $document.click(onDocumentClick);
}

module.exports = closeOnClickOutsideConfig;